angular.module('SpidApp')

.factory('Currency', function () {
	var Currency = function (params) {
		params = params || {}

		this.id      = params.id
		this.label   = params.label
		this.keycode = params.keycode
		this.symbol  = params.symbol
		this.rate    = params.rate
		this.coins   = params.coins
		this.bills   = params.bills
	}

	Currency.prototype.getDisplayName = function () {
		return this.label + ' (' + this.symbol + ')'
	}

	return Currency
})